import React, { Component, Fragment } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { withRouter } from 'react-router';
import moment from 'moment';

import { STATUS_CHANGE_REPORT_FORM_NAME } from 'Common/FormEnum';
import { StatusChangeReportFieldEnum as Fields } from 'Common/FieldEnum';
import { DatePickerField, CheckboxField } from 'Common/SemanticWrapper';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { YesNoOptions } from 'Common/FormHelper';

class StatusChangeReportFormContainer extends Component {
  AsOfDate = [
    { value: 0, label: 'Status Change Date' },
    { value: 1, label: 'Application Date' },
  ];

  SortBy = [
    { value: 0, label: 'Alpha Only' },
    { value: 1, label: 'School/Alpha' },
  ];

  ProvisionType = [
    { value: 0, label: 'Both' },
    { value: 1, label: 'CEP/Provision 2 Only ' },
    { value: 2, label: 'Traditional' },
  ];
  render() {
    const { loading, formValues } = this.props;
    return (
      <Fragment>
        <Form name={STATUS_CHANGE_REPORT_FORM_NAME}>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <Grid>
                  <Grid.Row>
                    <Grid.Column className="input-group--btn-group">
                      <ReduxFormButtonGroup
                        formName={STATUS_CHANGE_REPORT_FORM_NAME}
                        fieldName={Fields.AsOfDate}
                        name={Fields.AsOfDate}
                        options={this.AsOfDate}
                        value={formValues[Fields.AsOfDate]}
                        label={'As Of'}
                        disabled={loading}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Grid>
                  <Grid.Row>
                    <Grid.Column className="input-group--btn-group">
                      <ReduxFormButtonGroup
                        formName={STATUS_CHANGE_REPORT_FORM_NAME}
                        fieldName={Fields.SortBy}
                        name={Fields.SortBy}
                        options={this.SortBy}
                        value={formValues[Fields.SortBy]}
                        label={'Sort By'}
                        disabled={loading}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={8} className="input-group--btn-group">
                      <ReduxFormButtonGroup
                        formName={STATUS_CHANGE_REPORT_FORM_NAME}
                        fieldName={Fields.ProvisionType}
                        name={Fields.ProvisionType}
                        options={this.ProvisionType}
                        value={formValues[Fields.ProvisionType]}
                        label={'Provision Type'}
                        disabled={loading}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Grid>
                  <Grid.Row>
                    <Grid.Column className="input-group--btn-group">
                      <ReduxFormButtonGroup
                        label={'Print SSN'}
                        options={YesNoOptions}
                        formName={STATUS_CHANGE_REPORT_FORM_NAME}
                        value={formValues[Fields.PrintSSN]}
                        fieldName={Fields.PrintSSN}
                        disabled={loading}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Grid columns={4}>
                  <Grid.Row>
                    <Grid.Column>
                      <Field
                        label={'From Date'}
                        name={Fields.FromDate}
                        component={DatePickerField}
                        type="text"
                        openToDate={moment()}
                        disabled={loading}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <Field
                        label={'To Date'}
                        name={Fields.ToDate}
                        component={DatePickerField}
                        type="text"
                        openToDate={moment()}
                        disabled={loading}
                        maxDate={moment()}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <label>Filter by Action</label>
                  <Grid.Row>
                    <Grid.Column>
                      <Field
                        label={'Added'}
                        name={Fields.FilterAdded}
                        component={CheckboxField}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <Field
                        label={'Changed'}
                        name={Fields.FilterChanged}
                        component={CheckboxField}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <Field
                        label={'Withdrawn'}
                        name={Fields.FilterWithdrawn}
                        component={CheckboxField}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!moment(values[Fields.FromDate]).isValid()) {
    errors[Fields.FromDate] = 'Enter a valid From Date.';
  }
  if (!values[Fields.FromDate]) {
    errors[Fields.FromDate] = 'From Date must be set.';
  }

  if (!moment(values[Fields.ToDate]).isValid()) {
    errors[Fields.ToDate] = 'Enter a valid To Date.';
  }
  if (!values[Fields.ToDate]) {
    errors[Fields.ToDate] = 'To Date must be set.';
  }

  if (
    moment(values[Fields.FromDate]).isValid() &&
    values[Fields.FromDate] &&
    moment(values[Fields.ToDate]).isValid() &&
    values[Fields.ToDate] &&
    moment(values[Fields.ToDate]).isBefore(values[Fields.FromDate])
  ) {
    errors[Fields.ToDate] =
      'To Date must be greater than or equal to From Date.';
  }

  return errors;
};

const mapStateToProps = state => {
  return {
    formValues: getFormValues(STATUS_CHANGE_REPORT_FORM_NAME)(state),
    loading: false,
  };
};

const StatusChangeReportForm = reduxForm({
  form: STATUS_CHANGE_REPORT_FORM_NAME,
  validate,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(withRouter(connect(mapStateToProps)(StatusChangeReportFormContainer)));

export { StatusChangeReportForm };



// WEBPACK FOOTER //
// ./src/pages/statuschange/components/StatusChangeForm.js